import axios from 'axios'
import { ParentIds } from './treeModel'

const getShareDocumentUrl = (docId: string, snapshotId: string) =>
  `/doc/${docId}/share-to-sharepoint/?snapshot-id=${snapshotId}`

export const sendShareDocumentRequest = async (
  docId: string,
  snapshotId: string,
  filename: string,
  parentIds: ParentIds
): Promise<void> => {
  const url = getShareDocumentUrl(docId, snapshotId)
  const data = {
    docId,
    snapshotId,
    filename,
    _save: 1,
    ...parentIds
  }
  const formData = new FormData()
  for (const [key, value] of Object.entries(data)) {
    formData.append(key, String(value))
  }
  const headers = {
    "Content-Type": "multipart/form-data"
  }

  let response
  try {
    response = await axios.post(url, formData, {
      headers,
      validateStatus: status => [200, 401, 403, 404].includes(status)
    })
  } catch (exc) {
    const error = axios.isAxiosError(exc) ? exc.message : "Unknown error"
    throw new Error(error)
  }

  const errorCodeMessages: Record<number, string> = {
    401: "Unauthorized",
    403: "Forbidden",
    404: "Resource not found",
  }

  if (response.status in errorCodeMessages) {
    const errorMessage =
        response.data.message || errorCodeMessages[response.status]
    throw new Error(errorMessage)
  }

  // Fallback (if some other status slips through)
  if (response.status !== 200) {
    const error = response.data?.message || "Unexpected status"
    throw new Error(error)
  }
}
